import React, {useEffect, useState} from 'react';
import {useAppointmentStore} from "../stores/useAppointmentStore";
import {useAuthStore} from "../stores/useAuthStore";
import {Header} from "semantic-ui-react";
import {DynamicTable} from "pivot-table";
import {useLocation} from "react-router";
import CRUModal from '../components/CRUModal';
import {useUiStore} from "../stores/useUiStore";
import {useNavigate} from "react-router-dom";
import TableLegend from "./TableLegend";

const ScheduleAppointment = () => {
    const [modalState, setModalState] = useState({isOpen: false, mode: 'create', data: null});
    const [isCurrentEventEmpty, setIsCurrentEventEmpty] = useState(false);
    const [originalEventDataState, setOriginalEventDataState] = useState({});

    const fetchAppointmentEvents = useAppointmentStore(state => state.fetchAppointmentEvents);
    const updateAppointmentEvent = useAppointmentStore(state => state.updateAppointmentEvent);
    const appointmentEvents = useAppointmentStore(state => state.appointmentEvents);
    const loading = useAppointmentStore(state => state.loading);
    const error = useAppointmentStore(state => state.error);
    const ucdId = useAuthStore(state => state.ucdId);
    const churchPassword = useAuthStore(state => state.churchPassword);
    const isAdmin = useAuthStore(state => state.isAdmin);
    const location = useLocation();
    const appointmentDateContext = location.state?.data;

    const setBackgroundUrl = useUiStore(state => state.setBackgroundUrl);
    const navigate = useNavigate();

    useEffect(() => {
        console.log(loading);
    }, [loading]);

    const appointmentFields = [
        {
            name: 'firstNames',
            label: 'First Name',
            type: 'text',
            validation: {
                required: true
            }
        },
        {
            name: 'lastName',
            label: 'Last Name',
            type: 'text',
            validation: {
                required: true
            }
        },
        {
            name: 'spouseFirstName',
            label: 'Spouse First Name',
            type: 'text'
        },
        {
            name: 'spouseLastName',
            label: 'Spouse Last Name (if different)',
            type: 'text'
        },
        {
            name: 'numberInFamily',
            label: 'Number Of Family Members',
            type: 'number',
            validation: {required: true}
        },
        // Address Fields
        {
            name: 'address1',
            label: 'Street Address 1',
            type: 'text',
            validation: {
                required: true
            }
        },
        {
            name: 'city',
            label: 'City',
            type: 'text',
            validation: {
                required: true
            }
        },
        {
            name: 'state',
            label: 'State',
            type: 'select',
            options: [
                {key: 'AL', text: 'Alabama', value: 'AL'},
                {key: 'AK', text: 'Alaska', value: 'AK'},
                {key: 'AZ', text: 'Arizona', value: 'AZ'},
                {key: 'AR', text: 'Arkansas', value: 'AR'},
                {key: 'CA', text: 'California', value: 'CA'},
                {key: 'CO', text: 'Colorado', value: 'CO'},
                {key: 'CT', text: 'Connecticut', value: 'CT'},
                {key: 'DE', text: 'Delaware', value: 'DE'},
                {key: 'DC', text: 'Washington DC', value: 'DC'},
                {key: 'FL', text: 'Florida', value: 'FL'},
                {key: 'GA', text: 'Georgia', value: 'GA'},
                {key: 'HI', text: 'Hawaii', value: 'HI'},
                {key: 'ID', text: 'Idaho', value: 'ID'},
                {key: 'IL', text: 'Illinois', value: 'IL'},
                {key: 'IN', text: 'Indiana', value: 'IN'},
                {key: 'IA', text: 'Iowa', value: 'IA'},
                {key: 'KS', text: 'Kansas', value: 'KS'},
                {key: 'KY', text: 'Kentucky', value: 'KY'},
                {key: 'LA', text: 'Louisiana', value: 'LA'},
                {key: 'ME', text: 'Maine', value: 'ME'},
                {key: 'MD', text: 'Maryland', value: 'MD'},
                {key: 'MA', text: 'Massachusetts', value: 'MA'},
                {key: 'MI', text: 'Michigan', value: 'MI'},
                {key: 'MN', text: 'Minnesota', value: 'MN'},
                {key: 'MS', text: 'Mississippi', value: 'MS'},
                {key: 'MO', text: 'Missouri', value: 'MO'},
                {key: 'MT', text: 'Montana', value: 'MT'},
                {key: 'NE', text: 'Nebraska', value: 'NE'},
                {key: 'NV', text: 'Nevada', value: 'NV'},
                {key: 'NH', text: 'New Hampshire', value: 'NH'},
                {key: 'NJ', text: 'New Jersey', value: 'NJ'},
                {key: 'NM', text: 'New Mexico', value: 'NM'},
                {key: 'NY', text: 'New York', value: 'NY'},
                {key: 'NC', text: 'North Carolina', value: 'NC'},
                {key: 'ND', text: 'North Dakota', value: 'ND'},
                {key: 'OH', text: 'Ohio', value: 'OH'},
                {key: 'OK', text: 'Oklahoma', value: 'OK'},
                {key: 'OR', text: 'Oregon', value: 'OR'},
                {key: 'PA', text: 'Pennsylvania', value: 'PA'},
                {key: 'RI', text: 'Rhode Island', value: 'RI'},
                {key: 'SC', text: 'South Carolina', value: 'SC'},
                {key: 'SD', text: 'South Dakota', value: 'SD'},
                {key: 'TN', text: 'Tennessee', value: 'TN'},
                {key: 'TX', text: 'Texas', value: 'TX'},
                {key: 'UT', text: 'Utah', value: 'UT'},
                {key: 'VT', text: 'Vermont', value: 'VT'},
                {key: 'VA', text: 'Virginia', value: 'VA'},
                {key: 'WA', text: 'Washington', value: 'WA'},
                {key: 'WV', text: 'West Virginia', value: 'WV'},
                {key: 'WI', text: 'Wisconsin', value: 'WI'},
                {key: 'WY', text: 'Wyoming', value: 'WY'}
            ],
            validation: {
                required: true
            }
        },
        {
            name: 'zip',
            label: 'Zip Code',
            type: 'text',
            validation: {
                required: true,
                pattern: /^\d{5}(-\d{4})?$/,
                message: 'Please enter a valid ZIP code'
            }
        },
        // Contact Fields
        {
            name: 'phoneNumber',
            label: 'Telephone',
            type: 'text',
            validation: {
                required: true,
                pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                message: 'Please enter a valid phone number'
            }
        },
        {
            name: 'cellPhone1',
            label: 'Cell Phone',
            type: 'text',
            validation: {
                pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                message: 'Please enter a valid phone number'
            }
        },
        {
            name: 'cellPhone2',
            label: 'Secondary Cell Phone',
            type: 'text',
            validation: {
                pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
                message: 'Please enter a valid phone number'
            }
        },
        {
            name: 'emailAddress',
            label: 'Email Address - Used to receive confirmation email.',
            type: 'email',
            validation: {
                required: false,
                pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Please enter a valid email address'
            }
        },
        {
            name: 'emailAddress2',
            label: 'Secondary Email Address',
            type: 'email',
            validation: {
                pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Please enter a valid email address'
            }
        }
    ];

    // Helper function to check if an event is empty
    const isEventEmpty = (eventData) => {
        console.log('isEventEmptyData', eventData);

        if (!eventData) return true;

        // Fields to exclude from the empty check
        const excludedFields = [
            'appointmentTimeHour',
            'appointmentTimeMinute',
            'appointmentTimeAMPM',
            'numberInFamily',
            'eventTime',
            // Also exclude system/metadata fields
            '_id',
            'appointmentDatesId',
            'churchId',
            'ucdChurchId',
            'ucd_church_id',
            'church_login',
            'appointmentTimeTwentyFour',
            'appointmentReserved',
            'deleted',
            'oldSystemEventId',
            'oldSystemChurchId',
            'sitNumber',
            'isStaffOnly',
            'nfd',
            'marcoSubmitted',
            'dailyFileProcessed',
            'dateEntered',
            'dateUpdated',
            '__v',
            'appointmentDateFormatted',
            'churchName',
            'churchCity',
            'churchState'
        ];

        // Fields to check for emptiness
        const fieldsToCheck = [
            'lastName',
            'firstNames',
            'otherLastName',
            'otherFirstName',
            'spouseLastName',
            'spouseFirstName',
            'phoneNumber',
            'cellPhone1',
            'cellPhone2',
            'emailAddress',
            'emailAddress2',
            'address1',
            'address2',
            'city',
            'state',
            'zip',
            'name',
            'streetAddress',
            'staffPose',
            'staffName',
            'startImage',
            'endImage',
            'photoshootChurch'
        ];

        for (const field of fieldsToCheck) {
            if (eventData[field] && eventData[field].toString().trim() !== '') {
                console.log('Setting is empty false')
                setIsCurrentEventEmpty(false);
                return false; // Found a non-empty field
            }
        }

        if (eventData.children && Array.isArray(eventData.children) && eventData.children.length > 0) {
            console.log('Setting is empty false')
            setIsCurrentEventEmpty(false);
            return false;
        }

        if (eventData.photoOrder && Array.isArray(eventData.photoOrder) && eventData.photoOrder.length > 0) {
            console.log('Setting is empty false')
            setIsCurrentEventEmpty(false);
            return false;
        }

        const booleanFieldsToCheck = [
            'phoneNumberUnlisted',
            'cellPhone1Unlisted',
            'cellPhone2Unlisted',
            'emailAddressUnlisted',
            'emailAddress2Unlisted',
            'addressUnlisted'
        ];

        for (const field of booleanFieldsToCheck) {
            if (eventData[field] === true) {
                console.log('Setting is empty false')
                setIsCurrentEventEmpty(false);
                return false;
            }
        }
        console.log('Setting is empty true');
        setIsCurrentEventEmpty(true)
        return true;
    };

    useEffect(() => {
        async function fetchAppointmentEventsHandler() {
            if (appointmentDateContext._id && ucdId && churchPassword) {
                const params = {
                    appointment_date_id: appointmentDateContext._id,
                    ucd_church_id: ucdId,
                    password: churchPassword
                };
                await fetchAppointmentEvents(params, isAdmin);
            }
        }

        fetchAppointmentEventsHandler();
    }, []);

    useEffect(() => {
        if (modalState.isOpen) {
            setBackgroundUrl('https://schedule.ucdir.com/images/backgrounds/special-additions-550.jpg')
        } else {
            setBackgroundUrl('https://schedule.ucdir.com/images/backgrounds/getting-ready-550.jpg')
        }
    }, [modalState.isOpen]);

    const handleRUForm = (data) => {
        const modalMode = isAdmin ? 'update' : 'create';

        // Store original data and check if empty when admin is updating
        if (isAdmin && modalMode === 'update') {
            setOriginalEventDataState(data);
            isEventEmpty(data);
        }

        setModalState({
            isOpen: true,
            mode: modalMode,
            data: {
                ...data,
                ucd_church_id: ucdId,
                church_login: churchPassword,
                appointmentDatesId: data.appointmentDatesId
            }
        });
    };

    const handleClearEvent = async (data) => {
        if (!isAdmin) return;

        if (window.confirm('Are you sure you want to clear this appointment\'s information?')) {
            try {
                const clearedData = {
                    _id: data._id,
                    ucd_church_id: ucdId,
                    church_login: churchPassword,
                    appointmentDatesId: data.appointmentDatesId,
                    // Preserve the time information
                    eventTime: data.eventTime,
                    numberInFamily: 1,
                    // Clear all other fields
                    firstNames: '',
                    lastName: '',
                    spouseFirstName: '',
                    spouseLastName: '',
                    children: [],
                    address1: '',
                    address2: '',
                    addressUnlisted: false,
                    city: '',
                    state: '',
                    zip: '',
                    phoneNumber: '',
                    phoneNumberUnlisted: false,
                    cellPhone1: '',
                    cellPhone1Unlisted: false,
                    cellPhone2: '',
                    cellPhone2Unlisted: false,
                    emailAddress: '',
                    emailAddressUnlisted: false,
                    emailAddress2: '',
                    emailAddress2Unlisted: false,
                    // Add isNewSignup flag since we're clearing the event
                    isNewSignup: true
                };

                const savedData = await updateAppointmentEvent(clearedData, isAdmin);
                if (savedData) {
                    // Refresh the appointments list
                    const params = {
                        appointment_date_id: appointmentDateContext._id,
                        ucd_church_id: ucdId,
                        password: churchPassword
                    };
                    await fetchAppointmentEvents(params, isAdmin);
                }
            } catch (err) {
                console.error('Error clearing appointment:', err);
            }
        }
    };

    const handleSave = async (formData) => {
        try {
            const payload = {
                ...formData,
                ucd_church_id: ucdId,
                church_login: churchPassword
            };

            // Determine isNewSignup based on mode and whether the event is empty
            if (modalState.mode === 'create') {
                // For regular users creating new appointments, it's always a new signup
                payload.isNewSignup = true;
            } else if (modalState.mode === 'update' && isAdmin) {
                // For admins updating, check if the original event was empty
                payload.isNewSignup = isCurrentEventEmpty;
            }

            const savedData = await updateAppointmentEvent(payload, isAdmin);
            if (savedData) {
                setModalState({isOpen: false, mode: 'create', data: null});
                setIsCurrentEventEmpty(false); // Reset the state
                setOriginalEventDataState({}); // Reset original data

                if (!isAdmin) {
                    navigate(`/appointment-confirmation`, {state: {data: savedData}})
                } else {
                    // Refresh the appointments list for admin
                    const params = {
                        appointment_date_id: appointmentDateContext._id,
                        ucd_church_id: ucdId,
                        password: churchPassword
                    };
                    await fetchAppointmentEvents(params, isAdmin);
                }
            }
        } catch (err) {
            console.error('Error saving appointment:', err);
        }
    };

    let options;
    if (isAdmin) {
        options = {
            rowSelect: false,
            columnSorting: false,
            searchEnabled: false,
            pagination: false,
            rowsPerPageDisplay: false,
            export: {enabled: false, showExportAll: false, showExportSelected: false},
            selectedRowsTable: {enabled: false},
            tableName: 'appointment-table',
            rowFunctions: [
                {callback: handleRUForm, color: 'blue', icon: 'edit', title: 'Edit Timeslot'},
                {
                    callback: handleClearEvent,
                    color: 'red',
                    icon: 'trash',
                    position:"right",
                    title: 'Delete Timeslot'
                }
            ],
        };
    } else {
        options = {
            rowSelect: false,
            columnSorting: false,
            searchEnabled: false,
            pagination: false,
            rowsPerPageDisplay: false,
            export: {enabled: false, showExportAll: false, showExportSelected: false},
            selectedRowsTable: {enabled: false},
            rowFunctions: [
                {callback: handleRUForm, color: 'blue', icon: 'clock outline', name: 'Reserve Time'},
            ]
        };
    }

    const legendItems = {
        0: {permission: ['allow', 'all'], icon: 'edit', color: 'blue', label: 'Edit Timeslot'},
        1: {permission: ['allow', 'all'], icon: 'trash', color: 'red', label: 'Delete Timeslot'},
    }

    if (!appointmentDateContext) {
        return <div>No appointment date selected</div>;
    }

    return (
        <div className="section-wrapper">
            <p>{appointmentDateContext.appointmentDate}: Available time slots.</p>
            <div>
                <Header as="h2">
                    Step #2: <span style={{fontSize: '1.7rem', fontWeight: 'normal'}}>
                    Click on any time slot to continue with your photography appointment schedule.
                </span>
                </Header>
                <Header as="h3" style={{marginTop: '-10px'}}>
                    *Please use 2 consecutive time slots when scheduling 6 or more in a family. <br/> Use a time slot for multi and generation portrait sittings.
                </Header>
            </div>
            {loading === false ? (
                appointmentEvents.data.length === 0 ? (
                    <p>No open time slots available for the date you selected.</p>
                ) : (
                    <div className="table-wrapper" style={{marginTop: '30px', maxWidth: '700px'}}>

                        {isAdmin && (
                            <>
                                <TableLegend
                                    items={legendItems}
                                    hasPermission={() => true}
                                />
                                <div style={{height:10}}></div> {/* spacer */}
                            </>
                        )}

                        <DynamicTable
                            initialData={appointmentEvents}
                            options={options}
                            resetStateOnMount={true}
                        />


                        <CRUModal
                            isOpen={modalState.isOpen}
                            onClose={() => {
                                setModalState({isOpen: false, mode: 'create', data: null});
                                setIsCurrentEventEmpty(false); // Reset on close
                                setOriginalEventDataState({}); // Reset original data
                            }}
                            title={modalState.data ?
                                `${isAdmin ? 'Edit' : 'Schedule'} Appointment: ${appointmentDateContext.appointmentDate} - ${modalState.data.eventTime}`
                                : ''}
                            data={modalState.data}
                            fields={appointmentFields}
                            onSave={handleSave}
                            mode={modalState.mode}
                            loading={loading}
                            buttonLabels={{
                                genericCancelLabel: 'Cancel',
                                update: {
                                    saveLabel: 'Update Appointment',
                                    cancelLabel: 'Cancel'
                                },
                                create: {
                                    saveLabel: 'Reserve Appointment',
                                    cancelLabel: 'Cancel'
                                }
                            }}
                            error={error}
                        />
                    </div>
                )
            ) : (
                <p>Loading</p>
            )}
        </div>
    );
};

export default ScheduleAppointment;